import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { ComumModule } from '../../../../shared/comum.module';
import { translateLoaderNBS } from '../../../../shared/translate-loader/translateLoader';
import { BiRelatorioAnaliseService } from '../bi-relatorio-analise/bi-relatorio-analise.service';
import { AnalisePassagemBi03Component } from './analise-passagem-bi03.component';
import { AnalisePassagemBi03Service } from './analise-passagem-bi03.service';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    NgbModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    CalendarModule,
    TableModule,
    ButtonModule,
    DialogModule,
    DropdownModule,
    TooltipModule,
    InputTextModule,
    TreeTableModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    AnalisePassagemBi03Component,
    // AnalisePassagemBi03ListaGridComponent
  ],
  declarations: [
    AnalisePassagemBi03Component,
    // AnalisePassagemBi03ListaComponent,
    // AnalisePassagemBi03FiltroComponent,
    // AnalisePassagensFiltroDownloadComponent,
    // AnalisePassagemBi03ListaGridComponent
  ],
  providers: [
    AnalisePassagemBi03Service,
    BiRelatorioAnaliseService
  ]
})
export class AnalisePassagemBi03Module { }
